/** Bring a tour target into the visible page, under the sticky top bar. */

const EDGE = 12;

export function stickyHeaderBottom(): number {
  if (typeof document === "undefined") return 0;
  const nav = document.querySelector(".top-nav");
  if (!(nav instanceof HTMLElement)) return 0;
  const bottom = nav.getBoundingClientRect().bottom;
  return bottom > 0 ? bottom : 0;
}

export function targetInView(node: HTMLElement, headerBottom = 0): boolean {
  const rect = node.getBoundingClientRect();
  if (rect.width < 2 || rect.height < 2) return false;
  const topLimit = headerBottom + EDGE;
  const bottomLimit = window.innerHeight - EDGE;
  const visibleTop = Math.max(rect.top, topLimit);
  const visibleBottom = Math.min(rect.bottom, bottomLimit);
  const visible = visibleBottom - visibleTop;
  const need = Math.min(rect.height, 48);
  return visible >= need && rect.left < window.innerWidth && rect.right > 0;
}

function scrollParent(node: HTMLElement): HTMLElement | null {
  let parent = node.parentElement;
  while (parent) {
    const style = getComputedStyle(parent);
    const scrolls = /(auto|scroll)/.test(style.overflowY) && parent.scrollHeight > parent.clientHeight + 1;
    if (scrolls) return parent;
    parent = parent.parentElement;
  }
  return null;
}

/** Scroll once. Caller retries until `targetInView` or it gives up. Tall targets pin their top under the header. */
export function scrollTargetIntoView(node: HTMLElement, headerBottom = 0): void {
  if (targetInView(node, headerBottom)) return;
  const rect = node.getBoundingClientRect();
  if (rect.width < 2 || rect.height < 2) return;
  const topLimit = headerBottom + EDGE;
  const available = Math.max(48, window.innerHeight - topLimit - EDGE);
  const align = rect.height > available * 0.7 ? topLimit : topLimit + Math.max(0, (available - rect.height) / 2);
  const delta = rect.top - align;
  if (Math.abs(delta) < 2) return;
  const parent = scrollParent(node);
  if (parent) parent.scrollTop += delta;
  else window.scrollBy(0, delta);
}
